<template>
  <div class="container" style="padding: 0.5em 1em; background: white">
    <div class="search-wrap" style="height: 40px">
      <b-dropdown
        size="sm"
        :no-caret="true"
        id="ad_num"
        class="border"
        left
        variant="white"
        :text="sch_type_title"
        style="width: 150px; height: 40px"
      >
        <b-dropdown-item
          v-for="(v, k, i) in options"
          :key="i"
          @click="change_search(k)"
          style="font-size: 17px; padding-left: 0.2em"
          >{{ v }}</b-dropdown-item
        >
        <template #button-content>
          <div class="leftright" style="color: black; font-size: 0.8em">
            <span
              style="
                text-align: left;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: center;
                font-size: 18px;
                font-family: KoreanGD14R;
              "
              >{{ sch_type_title }}</span
            >
            <b-icon icon="chevron-down" font-scale="0.8"></b-icon>
          </div>
        </template>
      </b-dropdown>
      <b-input-group size="sm" style="flex: 1; margin-left: 5px;">
        <b-form-input
          class="inner-text"
          v-model="sch_val"
          @keyup.enter="change_val"
        ></b-form-input>
        <b-input-group-append>
          <b-button
            variant="primary"
            @click="search_record"
            style="width: 50px"
          >
            <b-icon
              icon="search"
              variant="white"
              style="width: 20px; height: 20px"
            ></b-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-button
        v-if="!hideReadAll"
        :variant="isAllRead ? 'primary' : 'secondary'"
        :class="{ check_btn_active: isAllRead }"
        class="check_btn1 check_btn_text1"
        @click="$emit('readAll')"
        >{{ $t("notify.read_all") }}</b-button
      >
      <template
        v-if="variant != 'today' && !$store.getters.getSiteForNotifyList"
      >
        <div
          v-if="variant == 'default'"
          class="custom-but"
          @click="check_all"
          style="margin-left: 5px"
        >
          <b-icon :icon="all ? 'check' : ''" class="icon-box"></b-icon>
          <span style="color: white">{{ $t("community.all") }}</span>
        </div>
        <b-button
          v-if="variant == 'default'"
          size="sm"
          variant="primary"
          @click="del_record"
          style="margin-left: 5px"
        >
          <b-icon
            icon="trash"
            variant="white"
            font-scale="1.4"
            style="font-size: 20px"
          ></b-icon>
        </b-button>
        <b-button
          v-if="variant != 'default'"
          variant="white"
          :class="['check_btn', mine ? 'check_btn_active' : '']"
          size="sm"
          @click="change_mine"
          style="margin-left: 5px"
        >
          {{
            this.variant == "user" ? $t("community.mine") : $t("inquire.mine")
          }}
        </b-button>
        <b-img
          v-if="variant != 'default'"
          @click="create_community"
          style="height: 40px; margin-left: 5px"
          :src="require('../../../../../assets/image/ic_write@2x.png')"
        />
      </template>
    </div>
    <b-pagination
      v-model="currentPage"
      ref="data-pagination"
      class="search-pagination"
      size="lg"
      align="center"
      :total-rows="count * 20"
      limit="5"
      :hide-ellipsis="true"
      page-class="pagination-item"
      prev-class="pagination-item"
      next-class="pagination-item"
      last-class="pagination-item"
      first-class="pagination-item"
      @change="chg_page"
      style="margin-bottom: 15px"
    />
  </div>
</template>
<script>
import Utils from "../../../../../config/utils";
export default {
  name: "SearchForm",
  props: {
    count: { type: Number },
    searchValue: { type: String },
    mine: { type: Boolean },
    variant: {
      type: String,
      default: "default",
    },
    isAllRead: {
      type: Boolean,
      default: false,
    },
    hideReadAll: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      sch_type_title: this.$c.ADMIN.SCH_FORM.f_title,
      sch_type: "f_title",
      all: false,
      sch_val: "",
      local_mine: false,
      options: {},
      currentPage: 1,
    };
  },
  methods: {
    change_mine() {
      this.local_mine = !this.local_mine;
      this.$emit("update:mine", this.local_mine);
    },
    create_community() {
      this.eventBus.$emit("checkTicketAvailable", () => {
        this.$emit("make");
      });
    },
    change_search(k) {
      this.sch_type_title = this.options[k];
      this.sch_type = k;
      this.$emit("update:searchType", this.sch_type);
    },
    check_all() {
      this.all = !this.all;
      this.$emit("check", this.all);
    },
    del_record() {
      this.$emit("delete");
    },
    search_record() {
      this.$emit("search");
    },
    chg_page(page) {
      this.$emit("change_page", page);
    },
    change_val() {
      this.$emit("update:searchValue", this.sch_val);
      this.$emit("search");
    },
  },
  mounted() {
    this.$emit("update:searchValue", this.sch_val);
    this.$emit("update:searchType", this.sch_type);
    this.options =
      this.variant == "inquire" ? this.$c.INQUIRE_FORM : this.$c.ADMIN.SCH_FORM;
  },
  inject: ["eventBus"],
  computed: {},
};
</script>
<style lang="scss" scoped>
@import "../../../../../assets/css/main/admin/Admin.scss";
@import "../../../../../assets/css/_vars.scss";

.search-wrap {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1em;
}

.check_box {
  display: flex;
  align-items: center;
  background: gray;
  color: white;
}

.icon-box {
  height: 1em;
  width: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2em;
  color: #ddddde;
  background: white;
  border-radius: 0.25rem;
  margin-right: 0.5em;
}

.custom-but {
  font-size: 0.8em;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ddddde;
  padding: 0.3em 0.5em;
  cursor: pointer;
  font-size: $fs_18;
  font-family: $korean_gd_14_r;
}

.check_btn {
  height: 50px;
  border-radius: 3px;
  color: $white;
  font-size: $fs_18;
  background-color: #ddddde;
  font-family: $korean_gd_14_r;
  width: 80px;
  height: 40px;
}

.check_btn_active {
  background-color: $c_457fff;
}
.check_btn1 {
  display: flex;
  width: 90px;
  height: 40px;
  border-radius: 3px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-left: 11px;
  background-color: #ddddde;
  padding-left: 0;
  padding-right: 0;
}
.check_btn_text1 {
  color: white;
  font-size: $fs_18;
  font-family: $korean_gd_14_r;
}
.inner-text {
  font-size: $fs_18;
  font-weight: 500;
  font-family: $korean_gd_14_r;
  height: 100% !important;
  padding-left: 10px;
}
.search-pagination {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/controls/search_form.vue